'use client';

import { forwardRef, HTMLAttributes, useEffect, useRef } from 'react';
import styles from './htmlExperience.module.scss';

export type HTMLExperienceProps = {
  content?: string;
} & HTMLAttributes<HTMLDivElement>;

export const HTMLExperience = forwardRef<HTMLDivElement, HTMLExperienceProps>(
  ({ content = '', ...props }, ref) => {
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
      if (!containerRef.current || !content) return;

      containerRef.current.innerHTML = '';

      const wrapper = document.createElement('div');
      wrapper.innerHTML = content;
      containerRef.current.appendChild(wrapper);

      const tpWidget = containerRef.current.querySelector('.trustpilot-widget');
      if (tpWidget && window.Trustpilot) {
        window.Trustpilot.loadFromElement(tpWidget, true);
      }
    }, [content]);

    return (
      <div
        ref={(node) => {
          containerRef.current = node;
          if (typeof ref === 'function') ref(node);
          else if (ref) ref.current = node;
        }}
        {...props}
        className={styles.htmlWrapper}
        suppressHydrationWarning
      />
    );
  },
);

HTMLExperience.displayName = 'HTMLExperience';
